
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface LoginRequiredProps {
  toggleDiagnostic?: () => void;
}

const LoginRequired: React.FC<LoginRequiredProps> = ({ toggleDiagnostic }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Login Required</CardTitle>
        <CardDescription>
          Please log in to see your personalized content.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-48 flex items-center justify-center bg-secondary/50 rounded-md">
          <p className="text-muted-foreground">Sign in to view this content</p>
        </div>
        {toggleDiagnostic && (
          <div className="mt-4 flex justify-center">
            <Button 
              variant="outline" 
              className="gap-2"
              onClick={toggleDiagnostic}
            >
              <AlertTriangle className="h-4 w-4" />
              Run Diagnostic Tool
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default LoginRequired;
